<template>
  <div id="listWidget" class="mb-4" :style="`padding-bottom: ${selectedEvent ? '128px' : '10px'}`">
    <div>
      <h4 class="mb-3">온도조절기 예약 {{ route.params.scheduleId ? '수정' : '등록' }}</h4>
    </div>

    <hr class="mb-3" />

    <div class="list-group mb-3">
      <div class="text-muted fs-12px mb-2"><b>요일 선택</b></div>
      <ListGroupItem style="border-radius: 1.2rem;">
        <div style="width: 100%;">
          <div class="btn-group" style="width: 100%;">
            <input type="checkbox" class="btn-check week-check" id="sun-check" @click="onWeekClick(0)" :checked="week[0] == 1">
            <label class="btn btn-outline-primary mb-0" for="sun-check" style="border-radius: 5px 0px 0px 5px;">일</label>

            <input type="checkbox" class="btn-check week-check" id="mon-check" @click="onWeekClick(1)" :checked="week[1] == 1">
            <label class="btn btn-outline-primary mb-0" for="mon-check">월</label>

            <input type="checkbox" class="btn-check week-check" id="tue-check" @click="onWeekClick(2)" :checked="week[2] == 1">
            <label class="btn btn-outline-primary mb-0" for="tue-check">화</label>

            <input type="checkbox" class="btn-check week-check" id="wed-check" @click="onWeekClick(3)" :checked="week[3] == 1">
            <label class="btn btn-outline-primary mb-0" for="wed-check">수</label>

            <input type="checkbox" class="btn-check week-check" id="thu-check" @click="onWeekClick(4)" :checked="week[4] == 1">
            <label class="btn btn-outline-primary mb-0" for="thu-check">목</label>

            <input type="checkbox" class="btn-check week-check" id="fri-check" @click="onWeekClick(5)" :checked="week[5] == 1">
            <label class="btn btn-outline-primary mb-0" for="fri-check">금</label>

            <input type="checkbox" class="btn-check week-check" id="sat-check" @click="onWeekClick(6)" :checked="week[6] == 1">
            <label class="btn btn-outline-primary mb-0" for="sat-check" style="border-radius: 0px 5px 5px 0px;">토</label>
          </div>
        </div>
      </ListGroupItem>
    </div>    

    <div class="list-group">
      <div class="text-muted fs-12px mb-2"><b>시간 설정</b></div>
      <ListGroupItem style="border-radius: 1.2rem;">
        <FullCalendar ref="calendarRef" :options="calendarOptions" />
      </ListGroupItem>
    </div>

    <div id="footer" class="app-footer ms-0" :style="`z-index: 1000; ${selectedEvent ? 'padding-top: 10px;' : ''}`">
      <footer class="mt-auto">
        <div class="row px-2" v-if="selectedEvent">
          <ListGroupItem class="mt-1">
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row">
                <div :class="`col-3`" :style="`margin-top: 8px`">
                  <label class="form-label w-normal">
                    시간
                  </label>
                </div>
                <div class="col">
                  <div class="d-flex" style=" text-align: center;">
                    <div class="datepicker-wrapper">
                      <i class="fa-regular fa-clock custom-clock-icon"></i>
                      <Datepicker style="width: 100%;"
                        :start-time="{ hours: selectedEvent.start.getHours(), minutes: selectedEvent.start.getMinutes() }"
                        :time-picker="true"
                        :is24="true"
                        :minutes-increment="30"
                        :no-hours-overlay="true"
                        :no-minutes-overlay="true"
                        format="HH:mm"
                        :placeholder="`${('0' + selectedEvent.start.getHours()).slice(-2)}:${('0' + selectedEvent.start.getMinutes()).slice(-2)}`"
                        @update:model-value="onStartTimeChange"
                      />
                    </div>

                    <div class="mx-1" style="margin-top: 6px;">- </div>

                    <div class="datepicker-wrapper">
                      <i class="fa-regular fa-clock custom-clock-icon"></i>
                      <Datepicker style="width: 100%;"
                        :start-time="{ hours: selectedEvent.end.getHours(), minutes: selectedEvent.end.getMinutes() }"
                        :time-picker="true"
                        :is24="true"
                        :minutes-increment="30"
                        :no-hours-overlay="true"
                        :no-minutes-overlay="true"
                        format="HH:mm"
                        :placeholder="`${('0' + selectedEvent.end.getHours()).slice(-2)}:${('0' + selectedEvent.end.getMinutes()).slice(-2)}`"
                        @update:model-value="onEndTimeChange"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem class="mt-1">
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row align-items-center">
                <div class="col-3">
                  <label class="form-label w-normal mb-0">사용</label>
                </div>
                <div class="col d-flex justify-content-end">
                  <div class="form-check form-switch m-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      :checked="selectedEvent.enabled !== false"
                      @change="onSlotEnabledChange"
                    >
                  </div>
                </div>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem class="mt-1">
            <Slider
              :name="`온도 ${selectedEvent.temp}&#176;c`"
              id="temperature"
              type="white"
              :default="selectedEvent.temp"
              :nameWidth="3"
              :min="tempMin"
              :max="tempMax"
              :step="tempStep"
              :isFloat="!isCoolingSchedule"
              value-suffix="°C"
              v-on:onSliderChanged="onTemperatureChanged"
            />
          </ListGroupItem>
          <ListGroupItem class="mt-1">
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row">
                <div :class="`col-3`" :style="`margin-top: 8px`">
                  <label class="form-label w-normal">
                    패턴
                  </label>
                </div>
                <div class="col">
                  <div class="btn-group btn-group-toggle" style="width: 100%;">
                    <button :class="`btn ${selectedEvent.pattern == 1 ? 'btn-primary' : 'btn-outline-primary'} ${selectedEvent.pattern == 1 ? 'selected' : 'no-selected'}`" 
                      style="border-radius: 10px 0px 0px 10px;" @click="(e) => onSelectPatternClick(e, 1)">
                      P1
                    </button>

                    <button :class="`btn ${selectedEvent.pattern == 2 ? 'btn-primary' : 'btn-outline-primary'} ${selectedEvent.pattern == 2 ? 'selected' : 'no-selected'}`" 
                      style="border-radius: 0px 0px 0px 0px;" @click="(e) => onSelectPatternClick(e, 2)">
                      P2
                    </button>

                    <button :class="`btn ${selectedEvent.pattern == 3 ? 'btn-primary' : 'btn-outline-primary'} ${selectedEvent.pattern == 3 ? 'selected' : 'no-selected'}`" 
                      style="border-radius: 0px 0px 0px 0px;" @click="(e) => onSelectPatternClick(e, 3)">
                      P3
                    </button>

                    <button :class="`btn ${selectedEvent.pattern == 4 ? 'btn-primary' : 'btn-outline-primary'} ${selectedEvent.pattern == 4 ? 'selected' : 'no-selected'}`" 
                      style="border-radius: 0px 0px 0px 0px;" @click="(e) => onSelectPatternClick(e, 4)">
                      P4
                    </button>

                    <button :class="`btn ${selectedEvent.pattern == 5 ? 'btn-primary' : 'btn-outline-primary'} ${selectedEvent.pattern == 5 ? 'selected' : 'no-selected'}`" 
                      style="border-radius: 0px 10px 10px 0px;" @click="(e) => onSelectPatternClick(e, 5)">
                      P5
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ListGroupItem>
        </div>
        <div :class="`row mt-${selectedEvent ? 3 : 0}`">
          <div class="col">
            <div class="btn-group" style="width: 100%;" v-if="selectedEvent">
              <button type="button" class="btn btn-outline-primary btn-lg" style="width: 100%" @click="onLeftClick" :disabled="!prevEvent">{{ "<" }}</button>
              <button type="button" class="btn btn-outline-primary btn-lg" style="width: 100%" @click="onRightClick" :disabled="!nextEvent">{{ ">" }}</button>
            </div>
          </div>
          <div class="col" />
          <div class="col">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              style="width: 100%"
              @click="onRegistClick"
            >
              {{ route.params.scheduleId ? '수정' : '등록' }}
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { ref, reactive, getCurrentInstance, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { buildTimerGroupMqttPayload, weekToDaysMask } from '@/common/utils/scheduleMqtt';
import Slider from '@/common/components/widgets/Slider.vue';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import { MQTTTempCommand } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';
import Axios, { ScheduleApi } from '@/api';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

const route = useRoute();
const router = useRouter();
const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id == route.params.groupId);
});
const device = computed(() => {
  return group.value ? group.value.devices.find(device => device._id == route.params.deviceId) : undefined;
});
const allDevices = computed(() => {
  const devices = [];
  zone.value.groups.forEach(group => {
    group.devices.forEach(device => {
      if (device.type == 2) { // 온도조절기
        devices.push(device);
      }
    });
  });
  return devices;
});

const now = new Date();
const year = now.getFullYear();
const month = now.getMonth(); // 0부터 시작
const day = now.getDate();

const week = ref([0, 0, 0, 0, 0, 0, 0]);
const events = ref([...Array(12)].map((_, i) => ({
  id: i + 1,
  start: new Date(year, month, day, i * 2, 0, 0),
  end: new Date(year, month, day, (i + 1) * 2, 0, 0),
  temp: 18.0,
  pattern: 0,
  enabled: true,
})));

/** TimerGroup index: 1·2=난방(9~35, 0.5°C), 3=냉방(16~30, 1°C) */
const isCoolingSchedule = computed(() => Number(route.params.index) === 3);
const tempMin = computed(() => (isCoolingSchedule.value ? 16 : 9));
const tempMax = computed(() => (isCoolingSchedule.value ? 30 : 35));
const tempStep = computed(() => (isCoolingSchedule.value ? 1 : 0.5));

const clampTemp = (temp) => {
  const n = Number(temp);
  if (Number.isNaN(n)) return tempMin.value;
  let v = Math.min(tempMax.value, Math.max(tempMin.value, n));
  if (isCoolingSchedule.value) {
    v = Math.round(v);
  }
  return v;
};

const selectedEvent = ref(undefined);
const prevEvent = computed(() => selectedEvent.value ? events.value.find(event => event.id == selectedEvent.value.id - 1) : undefined)
const nextEvent = computed(() => selectedEvent.value ? events.value.find(event => event.id == selectedEvent.value.id + 1) : undefined)
const calendarRef = ref(null);
const eventElementMap = new Map();
const schedule = ref(undefined);

const eventItems = computed(() => events.value.map(event => ({
  ...event,
  title: event.enabled === false
    ? '비활성'
    : (event.pattern > 0 ? `온도 ${event.temp}°c, 패턴 P${event.pattern}` : `온도 ${event.temp}°c`),
})));

const requestSchedule = async () => {
  try {
    const result = await Axios.get(ScheduleApi.SCHEDULE.replace(":id", route.params.scheduleId), { deviceId: route.params.deviceId });
    if (result.resultCode === '0000') {
      console.log(result.resultData)
      schedule.value = result.resultData;
      schedule.value.data = schedule.value.data.map(item => ({
        ...item,
        start: new Date(year, month, day, item.start.substr(0, 2), item.start.substr(3), 0),
        end: new Date(year, month, day, item.end.substr(0, 2), item.end.substr(3), 0),
        temp: clampTemp(item.temp),
        enabled: item.enabled !== false,
      }))
      week.value = schedule.value.week;
      events.value = schedule.value.data;
      refreshCalendar();
    } else {
      console.warn(result.resultMessage);
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    console.log(error);
    emitter.emit('showPopAlert', {
      description: "예약 조회에 실패했습니다.",
    });
  }
}

onBeforeMount(() => {
  if (route.params.scheduleId) {
    requestSchedule();
  }
})

const getStartMinTime = (event) => {
  if (event) {
    const datetime = new Date(event.start.getTime() + 30 * 60 * 1000)
    return new Date(year, month, day, datetime.getHours(), datetime.getMinutes(), 0)
  } else {
    return new Date(year, month, day, 0, 0, 0)
  }  
}

const getStartMaxTime = (event) => {
  if (event) {
    const datetime = new Date(selectedEvent.value.end.getTime() - 30 * 60 * 1000)
    return new Date(year, month, day, datetime.getHours(), datetime.getMinutes(), 0)
  } else {
    return new Date(year, month, day, 0, 0, 0)
  }  
}

const getEndMinTime = (event) => {
  if (event) {
    const datetime = new Date(selectedEvent.value.start.getTime() + 30 * 60 * 1000)
    return new Date(year, month, day, datetime.getHours(), datetime.getMinutes(), 0)
  } else {
    return new Date(year, month, day, 0, 0, 0)
  }  
}

const getEndMaxTime = (event) => {
  if (event) {
    const datetime = new Date(event.end.getTime() - 30 * 60 * 1000)
    return new Date(year, month, day, datetime.getHours(), datetime.getMinutes(), 0)
  } else {
    return new Date(year, month, day, 0, 0, 0)
  }  
}

const calendarOptions = ref({
  plugins: [
    timeGridPlugin,
    interactionPlugin,
  ],
  slotLabelFormat: {
    hour: 'numeric',
    minute: '2-digit',
    hour12: false
  },
  eventTimeFormat: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  },
  slotLabelInterval: '01:00',
  headerToolbar: false,
  dayHeaders: false,
  allDaySlot: false,
  slotDuration: '00:30:00',
  snapDuration: '00:30:00',
  initialView: "timeGridDay",
  events: eventItems.value,
  editable: false,
  selectable: false,
  eventDrop(info) {
    info.revert();
  },
  eventResize(info) {
    const events = info.view.calendar.getEvents();
    const event = info.event;
    const overlapEvents = events.filter(e => event.id != e.id && event.start < e.end && event.end > e.start);
    if (overlapEvents.length >= 2) {
      info.revert();
    } else if (overlapEvents.length == 1) {
      const overlapEvent = overlapEvents[0];
      if (overlapEvent.end.getHours() == event.end.getHours() && overlapEvent.end.getMinutes() == event.end.getMinutes()) {
        info.revert();
      } else {
        overlapEvent.setStart(event.end);
      }
    }

    events.forEach((e, index) => {
      if (index > 0) {
        if (e.start != events[index - 1].start) {
          e.setStart(events[index - 1].end);
        }
      }
    })
  },
  eventClick(info) {
    const foundItems = document.getElementsByClassName("selected-event");
    for (const item of foundItems) {
      item.style.border = "";
      item.classList.remove("selected-event");
    }

    const event = events.value.find(e => info.event.id == e.id);
    selectedEvent.value = event;
    info.el.style.border = "2px solid #666666";
    info.el.classList.add("selected-event");
  },
  eventDidMount(info) {
    eventElementMap.set(info.event.id, info.el);
    const targetEvent = events.value.find(e => e.id == info.event.id);
    if (targetEvent) {
      setTempColor(info.el, targetEvent);
    }
  }
});

const setTempColor = (elem, event) => {
  if (event.enabled === false) {
    elem.style.background = 'linear-gradient(to right, #CCCCCC, #DDDDDD)';
    elem.style.opacity = '0.55';
    const collection = elem.getElementsByClassName("fc-event-main-frame");
    if (collection.length > 0) {
      collection[0].style.color = '#666666';
    }
    return;
  }
  elem.style.opacity = '1';
  const tempColor = getColorByTemperature(event.temp);
  elem.style.background = tempColor.background;

  const collection = elem.getElementsByClassName("fc-event-main-frame");
  if (collection.length > 0) {
    collection[0].style.color = tempColor.color;
  }
}

const renderTempColor = () => {
  eventElementMap.forEach((elem, i) => {
    setTempColor(elem, events.value[i - 1]);
  })
}

const onWeekClick = (index) => {
  week.value[index] = week.value[index] ? 0 : 1;
}

const getElementByEvent = (event) => {
  return eventElementMap.get(`${event.id}`);
}

const onTemperatureChanged = (e) => {
  selectedEvent.value.temp = clampTemp(e);
  refreshCalendar();
}

const onSlotEnabledChange = (e) => {
  selectedEvent.value.enabled = !!e.target.checked;
  refreshCalendar();
}

const onSelectPatternClick = (e, value) => {
  if (selectedEvent.value.pattern == value) {
    selectedEvent.value.pattern = 0;
  } else {
    selectedEvent.value.pattern = value;
  }
  refreshCalendar();
}

const refreshCalendar = () => {
  const calendarApi = calendarRef.value.getApi();
  calendarApi.removeAllEvents();
  calendarApi.addEventSource(eventItems.value);

  renderTempColor();
  reselectEvent();
}

const onStartTimeChange = (time) => {
  const index = events.value.findIndex(event => event.id == selectedEvent.value.id);
  if (index > 0) {
    const newTime = new Date(year, month, day, time.hours, time.minutes, 0);    
    if (newTime >= getStartMinTime(prevEvent.value) && newTime <= getStartMaxTime(prevEvent.value)) {
      prevEvent.value.end = newTime;
      selectedEvent.value.start = newTime;
      refreshCalendar();
    } else {
      emitter.emit('showPopAlert', {
        description: `${moment(getStartMinTime(prevEvent.value)).format("HH:mm")}부터 ${moment(getStartMaxTime(prevEvent.value)).format("HH:mm")}까지 선택할 수 있습니다.`,
      });
    }
  }
}

const onEndTimeChange = (time) => {
  const index = events.value.findIndex(event => event.id == selectedEvent.value.id);
  if (index >= 0) {
    const newTime = new Date(year, month, day, time.hours, time.minutes, 0);    
    if (newTime >= getEndMinTime(nextEvent.value) && newTime <= getEndMaxTime(nextEvent.value)) {
      nextEvent.value.start = newTime;
      selectedEvent.value.end = newTime;
      refreshCalendar();
    } else {
      emitter.emit('showPopAlert', {
        description: `${moment(getEndMinTime(nextEvent.value)).format("HH:mm")}부터 ${moment(getEndMaxTime(nextEvent.value)).format("HH:mm")}까지 선택할 수 있습니다.`,
      });
    }
  }
}

const reselectEvent = () => {
  if (!selectedEvent.value) {
    return;
  }

  const el = getElementByEvent(selectedEvent.value);
  if (el) {
    el.style.border = "2px solid #666666";
    el.classList.add("selected-event");
  }
}

const onLeftClick = () => {  
  const foundItems = document.getElementsByClassName("selected-event");
  const el = foundItems[0].parentElement?.previousElementSibling?.firstElementChild;

  for (const item of foundItems) {
    item.style.border = "";
    item.classList.remove("selected-event");
  }

  selectedEvent.value = prevEvent.value;
  if (el) {
    el.style.border = "2px solid #666666";
    el.classList.add("selected-event");
    moveScroll(el)
  }
}

const onRightClick = () => {
  const foundItems = document.getElementsByClassName("selected-event");
  const el = foundItems[0].parentElement?.nextElementSibling?.firstElementChild;

  for (const item of foundItems) {
    item.style.border = "";
    item.classList.remove("selected-event");
  }

  selectedEvent.value = nextEvent.value;
  if (el) {
    el.style.border = "2px solid #666666";
    el.classList.add("selected-event");
    moveScroll(el)
  }
}

const moveScroll = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;

  const isPartiallyVisible = rect.top < (windowHeight - 210) && (rect.bottom - 60) > 0;
  if (!isPartiallyVisible) {
    const offsetTop = el.getBoundingClientRect().top + window.scrollY;
    const scrollTo = offsetTop - (windowHeight - 210) / 2;

    window.scrollTo({
      top: scrollTo,
      behavior: 'smooth'
    });
  }
}

const onRegistClick = async () => {
  const elems = document.getElementsByClassName("week-check");
  const checkedWeek = [];
  for (const elem of elems) {
    if (elem.checked) {
      checkedWeek.push(elem.value);
    }
  }
  
  if (checkedWeek.length == 0) {    
    emitter.emit('showPopAlert', {
      description: "요일을 선택해주세요.",
    });
    return;
  }

  const params = {
    week: week.value,
    data: events.value.map((e, i) => ({
      ...e,
      temp: clampTemp(e.temp),
      start: moment(e.start).format("HH:mm"),
      end: i == events.value.length - 1 ? "24:00" : moment(e.end).format("HH:mm"),
      enabled: e.enabled !== false,
    })),
  };
  console.log(params)

  const mqttPayload = buildTimerGroupMqttPayload({
    enable: schedule.value?.isOn ? 1 : 0,
    days: weekToDaysMask(params.week),
    data: params.data,
  });
  mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.SyncTimerGroup + `${route.params.index}`, mqttPayload);

  if (route.params.scheduleId) {
    await requestUpdateSchedule(route.params.scheduleId, params);
  } else {
    requestRegistSchedule(params);
  }

  if (device.value.item.allowSync) {
    await updateSyncSchedules();
  }

  emitter.emit('showPopAlert', {
    description: "예약이 수정되었습니다.",
    okCallback: () => router.go(-1),
    cancelCallback: () => router.go(-1),
  });
}

const updateSyncSchedules = async () => {
  const schedules = await requestZoneSchedules();
  const srcSchedules = schedules.filter(schedule => schedule.deviceId == route.params.deviceId);
  const tarSchedules = schedules.filter(schedule => schedule.deviceId != route.params.deviceId);

  if (srcSchedules.length == 0 || tarSchedules.length == 0) {
    console.warn("동기화할 예약이 없습니다.");
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  tarSchedules.forEach((schedule, i) => {
    const index = (i % 3);
    const device = allDevices.value.find(device => device._id == schedule.deviceId);
    if (!device) {
      console.warn(`장치가 존재하지 않습니다. deviceId: ${schedule.deviceId}`);
      return;
    } else {
      const mqttPayload = buildTimerGroupMqttPayload({
        enable: srcSchedules[index].isOn ? 1 : 0,
        days: weekToDaysMask(srcSchedules[index].week),
        data: srcSchedules[index].data,
      });
      // TimerGroupEnable 후 Sync로 슬롯별 arm 재적용 (Enable1이 12슬롯 일괄 arm하는 것 보정)
      mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.TimerGroupEnable + `${index + 1}`, srcSchedules[index].isOn ? '1' : '0');
      mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.SyncTimerGroup + `${index + 1}`, mqttPayload);
    }
  });
  
  return requestSyncSchedules({
    srcIds: srcSchedules.map(schedule => schedule._id),
    tarIds: tarSchedules.map(schedule => schedule._id)
  })
}

const requestSyncSchedules = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.post(ScheduleApi.SYNC_SCHEDULES, params);
      if (result.resultCode === '0000') {
        console.log(result.resultData);
        resolve(result.resultData);
      } else {
        console.warn(result.resultMessage);
        reject(result.resultMessage);
      }
    } catch (error) {
      console.log(error);
      reject("예약목록 동기화에 실패했습니다.");
    }
  });
};

const requestZoneSchedules = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.get(ScheduleApi.SCHEDULES_ALL, { zoneId: zone.value._id, isSync: true });
      if (result.resultCode === '0000') {
        // console.log(result.resultData[0].deviceId)
        resolve(result.resultData);
      } else {
        console.warn(result.resultMessage);
        reject(result.resultMessage);
      }
    } catch (error) {
      console.log(error);
      reject("예약목록 조회에 실패했습니다.");
    }
  });
};

const requestRegistSchedule = async (params) => {
  try {
    const result = await Axios.post(ScheduleApi.REGIST_SCHEDULE, params);
    if (result.resultCode === '0000') {
      emitter.emit('showPopAlert', {
        description: "예약이 등록되었습니다.",
        okCallback: () => router.go(-1),
        cancelCallback: () => router.go(-1),
      });
    } else {
      console.warn(result.resultMessage);
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    console.log(error);
    emitter.emit('showPopAlert', {
      description: "등록에 실패했습니다",
    });
  }
}

const requestUpdateSchedule = async (id, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(ScheduleApi.UPDATE_SCHEDULE.replace(":id", id), params);
      if (result.resultCode === '0000') {
        console.log(result.resultData);
        resolve(result);
      } else {
        console.warn(result.resultMessage);
        emitter.emit('showPopAlert', {
          description: result.resultMessage,
        });
        reject(result.resultMessage);
      }
    } catch (error) {
      console.log(error);
      emitter.emit('showPopAlert', {
        description: "수정에 실패했습니다.",
      });
      reject("수정에 실패했습니다.");
    }
  });
};

function hexToRGB(hex) {
  const cleanHex = hex.replace('#', '');
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
}

function getContrastingFontColor(hexColor) {
  const { r, g, b } = hexToRGB(hexColor);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 186 ? '#222222' : '#FFFFFF';
}

const getColorByTemperature = (temp) => {
  const colors = [
    '#5C8DFF', '#6EA2FF', '#7FB7FF', '#8FCAFF', '#9FDCFF', '#AEE8F8',
    '#A4F0E0', '#92EFC8', '#80EDA8', '#A3F077', '#C4F252', '#E6F43D',
    '#FFF236', '#FFE350', '#FFD169', '#FFBD7C', '#FFA98C', '#FF958F',
    '#FF7F82', '#FF696F', '#FF545C', '#FF4049', '#FF2C36', '#FF1824',
    '#F0101C', '#D50916', '#B00012', '#8B0000'
  ];

  const index = Math.floor(temp) - 9;
  if (index < 0 || index >= colors.length - 1) {
    return {
      background: 'linear-gradient(to right, #CCCCCC, #DDDDDD)',
      color: getContrastingFontColor('#CCCCCC')
    };
  }

  const fromColor = colors[index];
  const toColor = colors[index + 1];

  return {
    background: `linear-gradient(to right, ${fromColor}, ${toColor})`,
    color: getContrastingFontColor(fromColor)
  };
}
</script>

<style scoped>
.selected:hover {
  color: #ffffff;
  background-color: #1f6bff;
}
.no-selected:hover {
  color: #1f6bff;
  background-color: transparent;
}
.datepicker-wrapper {
  position: relative;
  width: 100%;
}

/* 기본 달력 아이콘 제거 */
:deep(.dp__input_icon) {
  display: none !important;
}

/* 왼쪽 아이콘 공간 확보 */
:deep(.dp__input) {
  padding-left: 2rem !important;
}

/* 시계 아이콘 - 왼쪽에 오버레이 */
.custom-clock-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #888888;
  font-size: 1rem;
  pointer-events: none;
  z-index: 9999;
}
</style>